module.exports = __webpack_public_path__ + "img/times.d77ff28f.jpg";